// extracted by mini-css-extract-plugin
export var container = "about-module--container--3dvfR";
export var alanImage = "about-module--alanImage--2Kmk_";
export var innerContainer = "about-module--innerContainer--95LBD";
export var title = "about-module--title--1TRFL";
export var contentTitle = "about-module--contentTitle--2SHnJ";